import { z } from 'zod';

import { Summary, SummaryLike } from '../summary';
import { entityTypeSchema } from './metadata-association';
import { deltaKindSchema } from './sync';

/**
 * An object ID originating from the external data source Edlink.
 */
export const edlinkIdSchema = z.string().brand<'edlinkId'>();
export const EdlinkId = edlinkIdSchema.parse.bind(edlinkIdSchema);
export type EdlinkId = z.infer<typeof edlinkIdSchema>;

export const edlinkDistrictEntrySchema = z.object({
  integrationId: edlinkIdSchema,
  districtId: edlinkIdSchema,
});
export type EdlinkDistrictEntry = z.infer<typeof edlinkDistrictEntrySchema>;

export const edlinkOrgChartImportSuccessSchema = z.object({
  type: entityTypeSchema,
  kind: deltaKindSchema,
  internalId: z.string().optional(),
  externalId: edlinkIdSchema.optional(),
});
export type EdlinkOrgChartImportSuccess = z.infer<typeof edlinkOrgChartImportSuccessSchema>;

export const edlinkOrgChartImportFailureSchema = z.object({
  type: entityTypeSchema,
  kind: deltaKindSchema,
  internalId: z.string().optional(),
  externalId: edlinkIdSchema.optional(),
  error: z.instanceof(Error),
});
export type EdlinkOrgChartImportFailure = z.infer<typeof edlinkOrgChartImportFailureSchema>;

export class EdlinkOrgChartImportSummary extends Summary<EdlinkOrgChartImportSuccess, EdlinkOrgChartImportFailure> {}
export type EdlinkOrgChartImportSummaryLike = SummaryLike<EdlinkOrgChartImportSuccess, EdlinkOrgChartImportFailure>;
